import React from "react";
import Footer from "../components/Shared/Footer";
import KnowyourCarb from "../components/Shared/Knowyourcarbcontent";

const ReducarbBlends = () => {

  return (
    <div>
      <section className="breadcrumb-section pt-0">
        <div className="container-fluid-lg">
          <div className="row">
            <div className="col-12">
              <div className="breadcrumb-contain">
                <h2>Reducarb Blends</h2>
                <nav>
                  <ol className="breadcrumb mb-0">
                    <li className="breadcrumb-item">
                      <a href="/">
                        <i className="fa-solid fa-house"></i>
                      </a>
                    </li>
                    <li className="breadcrumb-item active">
                    <span className="fw-bold">Redu</span>carb Blends
                    </li>
                  </ol>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </section>
      

<KnowyourCarb/>

<section className="fresh-vegetable-section section-lg-space">
  <div className="container-fluid-lg">
    <div className="review-title mb-3">
      <h1 className="font-lg mb-2">References:</h1>
    </div>
    <div className="references">
      <p><strong>1.</strong> <a href="#" className="hover-green-refernce font-xsm">PLOS ONE | https://doi.org/10.1371/journal.pone.0231572 May 21, 2020 </a></p>
      <p><strong>2.</strong> <a href="#" className="hover-green-refernce font-xsm">Diabetes Care 2012;35:434-45</a></p>
      <p><strong>3.</strong> <a href="#" className="hover-green-refernce font-xsm">Diabetes Care 25:434-445, 2012</a></p>
      <p><strong>4.</strong> <a href="#" className="hover-green-refernce font-xsm">J Nutr 2014;144:1423-9</a></p>
      <p><strong>5.</strong> <a href="#" className="hover-green-refernce font-xsm">Am J Clin Nutr 2020;111:677-68</a></p>
      <p><strong>6.</strong> <a href="#" className="hover-green-refernce font-xsm">Nutrients 2023, 15, 1358. https://doi.org/10.3390/nu15061358</a></p>
      <p><strong>7.</strong> <a href="#" className="hover-green-refernce font-xsm">Nutrients 2017, 9, 324; Circulation 2022, 146, 907-916</a></p>
      <p><strong>8.</strong> <a href="#" className="hover-green-refernce font-xsm">D. Jakubowicz, O. Froy / Journal of Nutritional Biochemistry 24 (2013) 1-5</a></p>
    </div>
  </div>
</section>
 

      <div>
        <Footer />
      </div>

      {/*
      
            <section className="fresh-vegetable-section section-lg-space custom-vegetable-section">
        <div className="container-fluid-lg custom-container">
          <div className="row gx-xl-5 gy-xl-0 g-3 ratio_148_1 custom-row">
            <div className="col-md-4 p-4 custom-col-left">
              <div className="fresh-image-2 custom-image">
                <div
                  className="bg-size blur-up lazyloaded custom-bg-image"
                  style={{
                    backgroundImage:
                      "url(../assets/images/Unhealthy/unhealthy-one.jpg)",
                    backgroundSize: "cover",
                    backgroundPosition: "center center",
                    backgroundRepeat: "no-repeat",
                    display: "block",
                  }}
                ></div>
              </div>
            </div>

            <div className="col-md-8 custom-col-right">
              <div className="fresh-contain p-center-left custom-content">
                <div>
                  <div className="delivery-list custom-delivery-list">
                    <div className="review-title custom-review-title">
                      <h1 className="font-lg mb-3 custom-title">
                        1. Unhealthy dietary habits
                      </h1>
                    </div>
                    <p className="font-xsm custom-paragraph">
                      <strong>
                        1) Do we have good and bad carbohydrates like good and
                        bad lipids (fat)?
                      </strong>
                      <br />
                      Yes. For simplicity, carbohydrates are broadly classified
                      as <strong>REFINED (Bad)</strong> and{" "}
                      <strong>COMPLEX (Good)</strong> carbohydrates.
                      <br></br>
                      <strong>
                        2) What is ‘Healthy Carbohydrate’ blend in Reducarb?
                      </strong>
                      Carbohydrates are the main source of energy under normal
                      conditions. When you eat any type of carbohydrates, they
                      are broken down into glucose and enter your bloodstream.
                      This increases blood sugar levels. The hormone insulin
                      helps your cells take up glucose and use it for energy.
                      Though carbohydrates increase sugar levels, it does not
                      mean you should avoid carbohydrates. The most important
                      factors in controlling blood sugar are:
                      <br></br>
                      <strong>A)</strong> The amount of carbohydrates eaten in a
                      meal <br></br>
                      <strong>B)</strong> Other food items eaten along with it
                      Reducarb provides a <strong>LOW QUANTITY</strong> of
                      carbohydrates per serve and helps in reducing daily
                      carbohydrate consumption when used as a meal replacement.
                      Qualitatively, it has{" "}
                      <strong>HEALTHY CARBOHYDRATE INDICES</strong>:
                      <ul>
                        <li>
                          Product should have more than 1g of fibre per 10g of
                          carbohydrates (
                          <code>per 10g carb: {">"}1g fibre</code> or{" "}
                          <code>10:{">"}1 carb:fibre ratio</code>).
                        </li>
                        <li>
                          Product should have {"<"}2g of free sugars per 1g of
                          fibre (<code>per 1g fibre: {"<"}2g free sugars</code>{" "}
                          or <code>1:{"<"}2 fibre:free sugar ratio</code>).
                        </li>
                      </ul>
                      (Ref: <i>PLOS ONE</i> |{" "}
                      <a
                        href="https://doi.org/10.1371/journal.pone.0231572"
                        
                        rel="noopener noreferrer"
                      >
                        https://doi.org/10.1371/journal.pone.0231572
                      </a>
                      , May 21, 2020)
                      <br />
                      <br />
                      <strong>
                        What is a Low-Carbohydrate Meal? How are they
                        classified?
                      </strong>
                      <br />
                      Defining low-carbohydrate diets is difficult because there
                      is no consistent definition. In a recently published
                      systematic review by the American Diabetes Association,
                      definitions were suggested for:
                      <ul>
                        <li>
                          <strong>Very-Low-Carbohydrate Diet:</strong> {"<"}10%
                          of daily calories from carbohydrates (commonly
                          referred to as Keto Diets).
                        </li>
                        <li>
                          <strong>Moderately Low-Carbohydrate Diet:</strong> 30
                          to {"<"}40% of daily calories from carbohydrates.
                        </li>
                      </ul>
                      Reducarb provides around 34-35% calories from
                      carbohydrates per serve, making it a{" "}
                      <strong>
                        moderately low-carbohydrate meal replacement
                      </strong>
                      . (Ref: <i>Diabetes Care</i> 25:434–445, 2012)
                      <br />
                      <br />
                      <strong>
                        What are the advantages of Low-Carbohydrate Meal Plans?
                      </strong>
                      <br />
                      Low-carbohydrate approaches have multiple advantages:
                      <ul>
                        <li>
                          <strong>a)</strong> Reduces blood glucose, forcing
                          your body to rely on energy sources other than
                          carbohydrates, which cuts your appetite. This is
                          reflected in a reduction of HbA1c, fasting, and
                          post-lunch blood glucose.
                        </li>
                        <li>
                          <strong>b)</strong> Reduces the burden on the pancreas
                          and lowers insulin resistance, independent of weight
                          loss.
                        </li>
                        <li>
                          <strong>c)</strong> Postpones the onset of diabetes or
                          reverses pre-diabetes in pre-diabetic individuals.
                        </li>
                        <li>
                          <strong>d)</strong> Promotes weight reduction and
                          helps in maintaining reduced weight in overweight and
                          obese individuals.
                        </li>
                        <li>
                          <strong>e)</strong> Improves lipids, sugar profiles,
                          and reduces weight in people with metabolic syndrome,
                          lowering the risk of diabetes and/or heart diseases.
                        </li>
                      </ul>
                      Not everyone will be willing or able to cut their
                      carbohydrate intake. However, cutting even some carbs
                      might lead to blood sugar and weight control benefits.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      
      <section className="fresh-vegetable-section section-lg-space">
        <div className="container-fluid-lg">
          <div className="row gx-xl-5 gy-xl-0 g-3 ratio_148_1">
          <div className="col-md-8">
              <div className="fresh-contain p-center-left">
                <div>
                  <div className="delivery-list">
                    <div className="review-title">
                      <h1 className="font-lg mb-3 ">
                        1.Carbohydrate blend
                      </h1>
                    </div>
                    <p className="font-xsm">
  <strong>What is dual protein blend in Reducarb?</strong><br />
  Reducarb has whey and soy source protein blend. Soy and whey proteins have demonstrated multiple benefits in people with pre-diabetes, Type 2 diabetes mellitus, and overweight and obese people undergoing weight management protocols.<br />


  <strong>Which is the plant protein in the dual protein blend?</strong><br />
  Reducarb has soy proteins which are plant-based. Research has shown that replacing some animal protein with soy protein may lead to improvements in some cardiovascular disease risk factors, with no changes in renal function. (Ref: <i>Diabetes Care</i> 2012;35:434–45).<br />

  <strong>Do soy proteins help in postmenopausal overweight women?</strong><br />
  Indeed, a recent study in 15 postmenopausal women with abdominal obesity showed that partially replacing animal proteins with soy-based foods improved insulin sensitivity (action of the sugar-lowering hormone, insulin). (Ref: <i>J Nutr</i> 2014;144:1423–9).<br />

  <strong>Do soy proteins help in the prevention of diabetes?</strong><br />
  A large meta-analysis published in the <i>American Journal of Clinical Nutrition</i> has concluded that dietary intakes of tofu, soy protein, and soy isoflavones are inversely associated with incident Type 2 diabetes. This supports recommendations to increase intakes of certain soy products for the prevention of Type 2 diabetes. (Ref: <i>Am J Clin Nutr</i> 2020;111:677–68).<br />

  <strong>Does soy intake help in reducing heart risks?</strong><br />
  Yes, indeed. One recently published meta-analysis demonstrated that soy consumption reduces the risks of diabetes and heart disease, and a specific quantity of soy products was the most beneficial for prevention. (Ref: <i>Nutrients</i> 2023, 15, 1358. <a href="https://doi.org/10.3390/nu15061358"  rel="noopener noreferrer">https://doi.org/10.3390/nu15061358</a>).<br />

  <strong>Does soy intake help in managing higher lipids?</strong><br />
  Soy does not contain cholesterol, but its plant components, including lecithin, stigmasterol, soy protein peptides, and isoflavones, improve lipid profiles through different mechanisms. (Ref: <i>Nutrients</i> 2017, 9, 324; <i>Circulation</i> 2022, 146, 907–916).<br />

  <strong>Does whey protein source benefit in combating pre-diabetes and obesity?</strong><br />
  Consumption of milk and dairy products has been associated with a reduced risk of metabolic disorders and cardiovascular disease. Recently, the beneficial physiological effects of whey protein on the control of food intake and glucose metabolism have been reported. Whey protein, via bioactive peptides and amino acids generated during gastrointestinal digestion, enhances the release of several hormones that lead to reduced food intake and increased satiety. The induced satiety and blood glucose reduction support the application of whey protein intake in managing Type 2 diabetes and obesity. (Ref: D. Jakubowicz, O. Froy / <i>Journal of Nutritional Biochemistry</i> 24 (2013) 1–5).
</p>

                  </div>

                 
                </div>
              </div>
            </div>
            <div className="col-md-4 p-4">
              <div className="fresh-image-2">
                <div
                  className="bg-size blur-up lazyloaded"
                  style={{
                    backgroundImage:
                      "url(../assets/images/Unhealthy/unhealthy-one.jpg)",
                    backgroundSize: "cover",
                    backgroundPosition: "center center",
                    backgroundRepeat: "no-repeat",
                    display: "block",
                  }}
                ></div>
              </div>
            </div>

           
          </div>
        </div>
      </section>

      <section className="fresh-vegetable-section section-lg-space">
        <div className="container-fluid-lg">
          <div className="row gx-xl-5 gy-xl-0 g-3 ratio_148_1">
            <div className="col-md-5 p-4 d-flex justify-content-center align-items-center">
            <div className="custom-image-container fresh-image-2">
                <img
                  src="../assets/images/Unhealthy/unhealthy-three.jpg"
                  alt=""
                  className="custom-image blur-up-img lazyloaded-img card_imd_fit"
                />
              </div>
            </div>

            <div className="col-md-7">

              
            <div className="fresh-contain p-center-left">
                <div>
                  <div className="delivery-list">
                    <div className="review-title">
                      <h1 className="font-lg mb-4 ">
                         3.Fat blend
                      </h1>
                    </div>
                    <div className="font-md">
                    <p className="">
  <strong>What is the fat source in Reducarb?</strong><br />
  Reducarb contains Oleic acid as a fat source. It is rich in Polyunsaturated Fatty Acids (PUFA) and Monounsaturated Fatty Acids (MUFA). PUFA and MUFA are known for their heart-protective action. They reduce the chances of fat accumulation in the blood vessels, thus helping seamless blood flow to vital organs.
  <br /><br />

  <strong>Is it a rich source of PUFA and MUFA?</strong><br />
  Yes, it contains 8.5g/100g of MUFA (in Him version) and 7.3g/100g of PUFA (in Her version).
  <br /><br />

  <strong>Does it contain saturated fat or trans fat?</strong><br />
  No, utmost care has been taken to avoid saturated and trans fats in Reducarb. Their levels are negligible, making it very safe.
  <br /><br />

  <strong>Which is the key fatty acid source in Reducarb?</strong><br />
  Reducarb is a good source of Linoleic acid (&gt;4% energy contribution from Linoleic acid). Linoleic acid is known for its beneficial role in preventing diabetes and metabolic disorders.
</p>

                    </div>
                  </div>
                </div>
              </div>
             
            </div>
          </div>
        </div>
      </section>

      <section className="fresh-vegetable-section section-lg-space">
        <div className="container-fluid-lg">
          <div className="row gx-xl-5 gy-xl-0 g-3 ratio_148_1">
            <div className="col-md-7">

            <div className="fresh-contain p-center-left">
                <div>
                  <div className="delivery-list">
                    <div className="review-title">
                      <h1 className="font-lg mb-3 ">4. Vitamin blend</h1>
                    </div>
                    <div className="">
                    <p className="font-xsm">
  <strong>Does it cover all my vitamin and mineral needs?</strong><br />
  Reducarb is a one or more meal replacement formula and is not intended to replace all meals of the day. Generally, vitamin and mineral deficiencies are not seen with short-term use. Further, Reducarb contains key vitamins and minerals up to 50% of the Recommended Dietary Allowances (RDAs). Please consult a dietician or healthcare professional for long-term use.
  <br /><br />

  <strong>Does it provide an adequate amount of key vitamins generally deficient in Indian people?</strong><br />
  Yes, utmost care has been taken to provide 50% RDA of key vitamins such as Vitamin B12, Folic Acid, Vitamin C, Vitamin A, and Vitamin D. It also provides 50% RDA of minerals like iron and 30% RDA of calcium. Additionally, it is a good source of Vitamin B1, B2, B3, and B6.
</p>

                      
                    </div>
                  </div>
                </div>
              </div>


             
            </div>

            <div className="col-md-5 p-4">
            <div className="custom-image-container fresh-image">
                <img
                  src="../assets/images/Unhealthy/unhealthy-four.jpg"
                  alt=""
                  className="custom-image blur-up-img lazyloaded-img card_imd_fit"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      
      <section className="fresh-vegetable-section section-lg-space">
        <div className="container-fluid-lg">
          <div className="row gx-xl-5 gy-xl-0 g-3 ratio_148_1">
            <div className="col-md-5 p-4 d-flex justify-content-center align-items-center">
            <div className="custom-image-container fresh-image-2">
                <img
                  src="../assets/images/Unhealthy/unhealthy-three.jpg"
                  alt=""
                  className="custom-image blur-up-img lazyloaded-img card_imd_fit"
                />
              </div>
            </div>

            <div className="col-md-7">

              
            <div className="fresh-contain p-center-left">
                <div>
                  <div className="delivery-list">
                    <div className="review-title">
                      <h1 className="font-lg mb-4 ">
                      5. Fiber blend
                      </h1>
                    </div>
                    <div className="font-md">
                    <p className="">
                    What is the fat source in Reducarb?

</p>

                    </div>
                  </div>
                </div>
              </div>
             
            </div>
          </div>
        </div>
      </section>
*/}


    </div>
  );
};

export default ReducarbBlends;
